import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { resetState, rerenderTable } from './../../store/productBundleSetTranslations.actions';

// components
import { ModalStepper } from 'dumb';
import ProductBundleSetTranslationsModalStep from './components/productBundleSetTranslationsModalStep';

// services
import { addProductBundleSetTranslations } from './../../productBundleSetTranslations.service';

// phrases
import phrases from './../../productBundleSetTranslations.phrases';

const ProductBundleSetTranslationsModalBatch = ({ id, onClose }) => {
	const modalRef = useRef();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const batchList = useSelector((store) => store.productBundleSetTranslations.batchList);

	const onNext = () => {
		setLoading(true);

		const payload = batchList.map((entry) => ({
			bundle_set: id,
			name: entry.name,
			language: entry.language?.value?.id ?? null,
		}));

		addProductBundleSetTranslations({ batch: payload })
			.then(() => {
				setLoading(false);
				dispatch(rerenderTable());
				onClose();
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const steps = [
		{
			component: <ProductBundleSetTranslationsModalStep />,
			title: phrases.MODAL_TITLE,
			onBack: onClose,
			onNext,
			loading,
			isValid: true,
			confirmButtonLabel: phrases.SUBMIT,
			defaultStyles: false,
			noScroll: false,
		},
	];

	useEffect(() => {
		return () => {
			dispatch(resetState());
		};
	}, [dispatch]);

	return (
		<ModalStepper header={phrases.MODAL_TITLE} onClose={onClose} ref={modalRef} isOpen steps={steps} showStep={false} />
	);
};

ProductBundleSetTranslationsModalBatch.propTypes = {
	onClose: PropTypes.func,
	id: PropTypes.number,
};

export default ProductBundleSetTranslationsModalBatch;
